// extracted by mini-css-extract-plugin
export default {"buttonBlock":"buttonBlock__NDU4Y","saveAndCancel":"saveAndCancel__NmFhN","deleteButton":"deleteButton__MmNlM"};